<div class="tw-flex tw-relative">
  @if (editable) {
    <div #tagElement
         (click)="addNewTagFn()"
         (colorPickerCancel)="cancel()"
         (colorPickerSelect)="createTag($event)"
         [(colorPicker)]="color"
         [(cpToggle)]="showColorPicker"
         [cpCancelButtonClass]="'btn btn-danger'"
         [cpCancelButtonText]="'lang.globals.cancel' | translate"
         [cpCancelButton]="true"
         [cpCloseClickOutside]="false"
         [cpIgnoredElements]="[tagElement]"
         [cpOKButtonClass]="'btn btn-primary'"
         [cpOKButtonText]="'lang.globals.addTag' | translate"
         [cpOKButton]="true"
         [cpOutputFormat]="'hex'"
         (cpPresetColorsChange)="colorService.setColor($event)"
         [cpSaveClickOutside]="false"
         [cpUseRootViewContainer]="true"
         [cpWidth]="'255px'"
         [cpMaxPresetColorsLength]="null"
         [cpPresetColors]="colorService.colorDef"
         [cpPresetEmptyMessage]="'lang.globals.noColorsAdded' | translate"
         [cpPresetLabel]="'lang.globals.presetColors' | translate"
         [ngClass]="tagLoading ? 'disabled' : null"
         class="tw-flex tw-items-center tag-input tag tw-cursor-pointer tw-mr-1 tw-border-solid tw-border tw-border-sbBlue-200 dark:tw-bg-sbGrayBlue-950">
      <sb-icon icon="tag" class="tw-text-sbBlue-500" style="font-size: 1rem;"></sb-icon>
      @if (addNewTag) {
        <div [@slideInOut] class="tw-ml-2 tw-relative">
          <input #newTagElement (keydown.enter)="doAutocomplete($event)"
                 (ngModelChange)="getStringForLookup($event)" [(ngModel)]="newTag"
                 [disabled]="tagLoading || showColorPicker" [placeholder]="'lang.globals.newTag' | translate"
                 class="form-control slideInput"
                 style="width: 70px; font-size: 0.8rem;font-weight: 600;height: 16px;margin: 0;"/>
        </div>
      }
    </div>
  }

  @if (tagEntities) {
    @if (tagEntities.length > tagCount()) {
      @if (!showAllTags) {

        <div class="tw-flex">
          <span (hidden)="visible = false" (shown)="visible = true" [ngbPopover]="popContent" autoClose="outside"
                class="tag grey-bg white tw-cursor-pointer" container="body" popoverClass="tag-container">
              <sb-icon class="tw-mr-1" icon="tags"></sb-icon>
            {{ tagEntities ? tagEntities.length : null }}
          </span>
        </div>
      } @else {
        <ng-container [ngTemplateOutlet]="tagList"></ng-container>
      }
    } @else {
      <ng-container [ngTemplateOutlet]="tagList"></ng-container>
    }
  }
</div>
<ng-template #popContent>
  <div class="tw-flex">
    <ng-container [ngTemplateOutlet]="tagList"></ng-container>
  </div>
</ng-template>

<ng-template #tagList>
  @for (tagEntity of tagEntities; track $index; let first = $first) {
    <span
      [@popup]
      [style.background]="'#'+tagEntity.tag.color"
      [style.boxShadow]="'0 0 9px #' + tagEntity.tag.color +'6b'"
      [style.color]="getFontcolor(tagEntity.tag)"
      class="tag tw-mr-1 tw-cursor-pointer">
          @if (editable) {
            <sb-icon (click)="removeTagEntity(tagEntity.tag.id, dtoType, dtoId)" class="tw-mr-1"
                     icon="cancel" style="font-size: .7rem;"></sb-icon>
          }
      <span [innerHTML]="tagEntity.tag.name | truncate: 5"></span>
        </span>
  }

</ng-template>
